import LMSDispatcher from "../LMSDispatcher";

import { IApi, Api } from '../../utilities/Api';
import { ApiRequest } from '../../utilities/ApiRequest';
import * as ACTIONCONTANTS from './ActionConstants';
import IMeasuredDetails, { MeasuredDetails } from "../../models/measurement/MeasuredDetails";
import { InstrumentDetails, IInstrumentDetails } from "../../models/measurement/InstrumentDetails";
import { SAMPLE_MEASUREMENT_APPROVE, SAMPLE_MEASUREMENT_REJECT, MEASUREMENT_INSTRUMENT_STOP, MEASUREMENT_INSTRUMENT_RESUME, MEASUREMENT_OVERVIEW_DETAILS } from './ActionConstants';
import IKeyedInDetailsData from '../../models/measurement/KeyedInDetailsData';
import { KeyedInDetails } from '../../models/measurement/KeyedInDetails';
import { KeyedInDetailsData } from '../../models/measurement/KeyedInDetailsData';
import { CalculatedDetails, ICalculatedValues, ICalculatedDetails, CalculatedValues } from "../../models/measurement/CalculatedDetails";
import { ISampleOverviewData } from '../../models/sample/SampleOverviewData';
import SampleOverviewData from '../../models/sample/SampleOverviewData';
import i18next from "i18next";

class MeasurementActions {
    private readonly api: IApi;

    constructor() {
        this.api = new Api(ACTIONCONTANTS.SAMPLE_ENDPOINT);
    }

    async startMeasurement(id: string, requestId: any): Promise<void> {
        try {
            const request = new ApiRequest("/measurements/start/" + id + "/sample", requestId, "", i18next.t("Start Measuring"));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SAMPLE_MEASUREMENT_START,
                payload: {
                    data: result.data,
                    message: result.message,
                    isMeasurementStart: true,
                }
            });
        } catch (error) {
            throw error.message;
        }
    }

    async startMultipleMeasurement(sampleIdList: string, requestId: any): Promise<void> {
        try {
            const payload = {
                sampleIdList: sampleIdList
            }
            const request = new ApiRequest("/Measurements/measureall", requestId, payload, i18next.t("Start Measuring"));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SAMPLE_MEASUREMENT_MULTIPLE_START,
                payload: {
                    data: result.data,
                    message: result.message,
                    isMeasurementStart: true,
                }
            });
        } catch (error) {
            throw error.message;
        }
    }

    async reMeasureMeasurement(id: string, requestId: any, isSetActive?: boolean): Promise<void> {
        try {
            const request = new ApiRequest("/measurements/remeasure/" + id + "/sample/"+isSetActive, requestId, "", i18next.t("Start Measuring"));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SAMPLE_MEASUREMENT_REMEASURE,
                payload: {
                    data: result.data,
                    message: result.message,
                    isMeasurementStart: true,
                }
            });
        } catch (error) {
            throw error.message;
        }
    }

    async reMeasureMultipleMeasurement(sampleIdList: string, requestId: any): Promise<void> {
        try {
            const payload = {
                sampleIdList: sampleIdList
            }
            const request = new ApiRequest("/Measurements/remeasureall", requestId, payload, i18next.t("Start Measuring"));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SAMPLE_MEASUREMENT_MULTIPLE_REMEASURE,
                payload: {
                    data: result.data,
                    message: result.message,
                    isMeasurementStart: true,
                }
            });
        } catch (error) {
            throw error.message;
        }
    }

    async stopMeasurement(id: string, measurementId: string, requestId: any): Promise<void> {
        try {
            const request = new ApiRequest("/measurements/stop/" + id + "/sample/" + measurementId + "/measurement", requestId, i18next.t("Stop Measuring"));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SAMPLE_MEASUREMENT_STOP,
                payload: {
                    data: result.data,
                    message: result.message,
                    isMeasurementStart: false
                }
            });
        } catch (error) {
            throw error.message;
        }
    }

    async completeMeasurement(id: string, measurementId: string, requestId: any): Promise<void> {
        try {
            const request = new ApiRequest("/measurements/complete/" + id + "/sample/" + measurementId + "/measurement", requestId, i18next.t("complete Measurement"));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SAMPLE_MEASUREMENT_COMPLETE,
                payload: {
                    data: result.data,
                    message: result.message,
                    isMeasurementStart: false
                }
            });
        } catch (error) {
            throw error.message;
        }
    }

    async pauseMeasurement(id: string, measurementId: string, requestId: any): Promise<void> {
        try {
            const request = new ApiRequest("/measurements/pause/" + id + "/sample/" + measurementId + "/measurement",
                requestId, "", i18next.t("Stop Measuring")); const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SAMPLE_MEASUREMENT_PAUSE,
                payload: {
                    data: result.data,
                    message: result.message,
                    isMeasurementStart: false
                }
            });
        } catch (error) {
            throw error.message;
        }
    }

    async approveSampleMeasurement(id: string, measurementId: string, requestId: any): Promise<void> {
        try {
            const request = new ApiRequest("/measurements/approve/" + id + "/sample/" + measurementId + "/measurement",
                requestId, "", i18next.t("Approve Measuring"));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SAMPLE_MEASUREMENT_APPROVE,
                payload: {
                    data: result.data,
                    message: result.message,
                    isMeasurementApproved: true
                }
            });
        } catch (error) {
            throw error.message;
        }
    }


    async approveMultipleSampleMeasurement(sampleArray: any, measurementArray: any, requestId: any): Promise<void> {
        try {
            const payload = {
                sampleIdList: sampleArray,
                measurementIdList: measurementArray
            };
            const request = new ApiRequest("/measurements/approveall",
                requestId, payload, i18next.t("Approve Measuring"));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SAMPLE_MEASUREMENT_MULTIPLE_APPROVE,
                payload: {
                    data: result.data,
                    message: result.message,
                    isMeasurementApproved: true
                }
            });
        } catch (error) {
            throw error.message;
        }
    }

    async rejectSampleMeasurement(id: string, measurementId: string, requestId: any): Promise<void> {
        try {
            const request = new ApiRequest("/measurements/reject/" + id + "/sample/" + measurementId + "/measurement",
                requestId, "", i18next.t("Reject Measuring"));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SAMPLE_MEASUREMENT_REJECT,
                payload: {
                    data: result.data,
                    message: result.message,
                    isMeasurementRejected: true
                }
            });
        } catch (error) {
            throw error.message;
        }
    }

    async rejectMultipleSampleMeasurement(sampleArray: any, measurementArray: any, requestId: any): Promise<void> {
        try {
            const payload = {
                sampleIdList: sampleArray,
                measurementIdList: measurementArray
            };
            const request = new ApiRequest("/measurements/rejectall", requestId, payload, i18next.t("Reject Measuring"));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SAMPLE_MEASUREMENT_MULTIPLE_APPROVE,
                payload: {
                    data: result.data,
                    message: result.message,
                    isMeasurementRejected: true
                }
            });
        } catch (error) {
            throw error.message;
        }
    }


    // new api integrated
    async getSampleMeasurementDetails(id: string) {
        try {
            const request = new ApiRequest("/measurements/" + id + "/sample", "", null, i18next.t("Unable to fetch measurement data."));
            const result = await this.api.get(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SAMPLE_MEASUREMENT_DETAILS,
                payload: {
                    data: result.data
                }
            });
        } catch (error) {
            throw error.message;
        }
    }

    async getInstrumentMeasurementDetails(sampleId: string, measurementId: string) {
        try {
            const request = new ApiRequest(`/measurements/${sampleId}/${measurementId}/instruments`, "", null, i18next.t("Unable to fetch instrument measurement data."));
            const result = await this.api.get(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SAMPLE_INSTRUMENT_MEASUREMENT_DETAILS,
                payload: {
                    data: result.data
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async getInstrumentDetails(sampleId: string, measurementId: string, instrumentId: string) {
        try {
            const request = new ApiRequest(`/measurements/${sampleId}/${measurementId}/instrument/${instrumentId}/details`, "", null, i18next.t("Unable to fetch instrument measurement data."));
            const result = await this.api.get(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SELECTED_SAMPLE_INSTRUMENT_MEASUREMENT_DETAILS,
                payload: {
                    data: result.data
                }
            });
        } catch (error) {
            throw error;
        }
    }


    convertResponseData(data: any): IMeasuredDetails {
        const instrumentDetails: IInstrumentDetails[] = [];
        data.instrumentDetails.forEach((element: any) => {
            instrumentDetails.push(new InstrumentDetails(element.id, element.name, element.count, element.directionCounts,
                element.properties, element.readings, element.instrumentStatus, element.positionCount, element.statistics,
                element.propertyMeans, element.positionMeans, element.isAutoLine, element.measurementId));
        });
        return new MeasuredDetails(data.id, data.name, data.description, data.isEnabled,
            data.measurementId, data.orderId, data.sampleDate, data.setId, instrumentDetails);
    }

    async getSampleKeyedInDetails(sampleid: string, measurementId: string) {
        try {
            const request = new ApiRequest(`/measurements/${sampleid}/${measurementId}/keyedins`, "", null, i18next.t("Unable to fetch measurement data."));
            const result = await this.api.get(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SAMPLE_MEASUREMENT_KEYEDINS,
                payload: {
                    data: result.data
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async getKeyedInDetails(sampleId: string, measurementId: string, propertyId: string) {
        try {
            const request = new ApiRequest(`/measurements/${sampleId}/${measurementId}/keyedin/${propertyId}/details`, "", null, i18next.t("Unable to fetch keyedIn measurement data."));
            const result = await this.api.get(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SAMPLE_MEASUREMENT_KEYEDIN_DETAILS,
                payload: {
                    data: result.data
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async postCountData(sendCount: any, requestId: any) {
        try {

            const request = new ApiRequest("/measurements/update/keyedin", requestId, sendCount, i18next.t("Unable to fetch measurement data."));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SAMPLE_MEASUREMENT_KEYEDIN_COUNT_DETAILS,
                payload: {
                    data: result.data,
                    status: result.status,
                }
            });
        } catch (error) {
            throw error;
        }
    }

    // instrument level
    async startInstrumentMeasurement(sampleId: string, measurementId: string, instrumentId: string, requestId: any): Promise<void> {
        try {
            const request = new ApiRequest(`/measurements/start/${sampleId}/sample/${measurementId}/measurement/${instrumentId}/instrument`, requestId, "", i18next.t("Start Measuring"));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.MEASUREMENT_INSTRUMENT_START,
                payload: {
                    data: result.data,
                    message: result.message,
                    isMeasurementStart: true,
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async stopInstrumentMeasurement(sampleId: string, measurementId: string, instrumentId: string, requestId: any): Promise<void> {
        try {
            const request = new ApiRequest(`/measurements/stop/${sampleId}/sample/${measurementId}/measurement/${instrumentId}/instrument`, requestId, "", i18next.t("Start Measuring"));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.MEASUREMENT_INSTRUMENT_STOP,
                payload: {
                    data: result.data,
                    message: result.message,
                    isMeasurementStart: true,
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async remeasureInstrumentMeasurement(sampleId: string, measurementId: string, instrumentId: string, requestId: any): Promise<void> {
        try {
            const request = new ApiRequest(`/measurements/remeasure/${sampleId}/sample/${measurementId}/measurement/${instrumentId}/instrument`,
                requestId, "", i18next.t("Start Measuring"));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.MEASUREMENT_INSTRUMENT_REMEASURE,
                payload: {
                    data: result.data,
                    message: result.message,
                    isMeasurementStart: true,
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async resumeInstrumentMeasurement(sampleId: string, measurementId: string, instrumentId: string, requestId: any): Promise<void> {
        try {
            const request = new ApiRequest(`/measurements/resume/${sampleId}/sample/${measurementId}/measurement/${instrumentId}/instrument`,
                requestId, "", i18next.t("Resuming Measured Property"));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.MEASUREMENT_INSTRUMENT_RESUME,
                payload: {
                    data: result.data,
                    message: result.message,
                    isMeasurementStart: true,
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async getSampleCalculatedDetails(id: string, measurementId: string) {
        try {
            const request = new ApiRequest("/measurements/sample/" + id + "/" + measurementId + "/details/calculated", "", null, i18next.t("Unable to fetch measurement data."));
            const result = await this.api.get(request);
            const data = this.convertCalculatedResponseData(result.data);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SAMPLE_MEASUREMENT_CALCULATED_DETAILS,
                payload: {
                    data: result.data
                }
            });
        } catch (error) {
            throw error;
        }
    }


    convertCalculatedResponseData(data: any): ICalculatedDetails[] {
        const calculatedValues: ICalculatedValues[] = [];
        const calculatedDetails: ICalculatedDetails[] = [];

        data.forEach((element: any) => {
            element.calculatedValues.forEach((item: any) => {
                calculatedValues.push(new CalculatedValues(item.position, item.count,
                    item.value, item.valueRange, item.decimals));

            });

            const calculatedDetail = new CalculatedDetails(data.id, data.name, data.unit, calculatedValues);
            calculatedDetails.push(calculatedDetail);
        });
        return calculatedDetails;
    }


    async getDefaultInstrumentdata(id: string, instrumentId: string) {
        try {
            const request = new ApiRequest(`/measurements/${id}/details/${instrumentId}/measured`, "", null,
            i18next.t("Unable to fetch measured data."));
            const result = await this.api.get(request);
            console.log("RESDATA ", result.data);
            const data = this.convertMeasuredResponse(result.data);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SAMPLE_MEASUREMENT_MEASURED_DETAILS,
                payload: { data: data }
            });
        } catch (error) {
            throw error.message;
        }
    }

    convertMeasuredResponse(data: any): IMeasuredDetails {
        const instrumentDetails: IInstrumentDetails[] = [];
        data.instrumentDetails.forEach((element: any) => {
            console.log("object 123456 ", element)
            instrumentDetails.push(new InstrumentDetails(element.id, element.name, element.count, element.directionCounts,
                element.properties, element.readings, element.instrumentStatus, element.positionCount, element.statistics,
                element.propertyMeans, element.positionMeans, element.isAutoLine, element.measurementId));
        });
        return new MeasuredDetails(data.id, data.name, data.description, data.isEnabled,
            data.measurementId, data.orderId, data.sampleDate, data.setId, instrumentDetails);
    }

    // overview
    async getMeasurementOverviewDetail(id: string) {
        try {
            const request = new ApiRequest("/sample/" + id + "/overview", "", null, i18next.t("Unable to fetch measurement overview data."));
            const result = await this.api.get(request);
            const data = this.convertOverviewData(result.data);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.MEASUREMENT_OVERVIEW_DETAILS,
                payload: {
                    data
                }
            });
        } catch (error) {
            throw error.message;
        }
    }

    convertOverviewData(data: any): ISampleOverviewData {
        return new SampleOverviewData(data.id, data.name, data.measurementId || "", data.properties);
    }

    //resume
    async resumeMeasurement(sampleid: string, measurementId: string, requestId: any): Promise<void> {
        try {
            const request = new ApiRequest(`/measurements/resume/${sampleid}/sample/${measurementId}/measurement`, requestId, "", i18next.t("Resume Measuring"));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SAMPLE_MEASUREMENT_RESUME,
                payload: {
                    data: result.data,
                    message: result.message,
                    isMeasurementStart: true,
                }
            });
        } catch (error) {
            throw error.message;
        }
    }


}

const measurementActions = new MeasurementActions();
export default measurementActions;